import { DOCUMENT } from '@angular/common';
import { WizDividerBase } from './wiz-divider.component';
import { ElementRef, ViewContainerRef, Renderer2, ChangeDetectorRef, Component, Inject } from '@angular/core';

/**
 * Implémentation verticlae du WizBaseDivider
 */
@Component({
  selector: '<wiz-v-divider></wiz-v-divider>',
  templateUrl: './wiz-divider.component.html',
  styleUrls: ['./wiz-v-divider.component.scss']
})
export class WizVDividerComponent extends WizDividerBase {
  constructor(public elementRef: ElementRef,
              public vcRef: ViewContainerRef,
              public  renderer: Renderer2,
              protected cdref: ChangeDetectorRef,
              @Inject(DOCUMENT) protected document: Document) {
    super(elementRef, vcRef, renderer, cdref, document);
  }

  /**
   * Retourne la direction du divider divider: 'V' pour vertical
   */
  get direction(): 'H' | 'V' {
    return 'V';
  }
}
